import React, { Component } from 'react'
import axios from 'axios'
import { SERVER_LISTING, DELETE_SERVER_URL, SERVER_TOGGAL, LOGIN_URL } from '../../../config/rest_endpoints'
import { getUser } from '../../../actions/session'
import { Notifications } from '../../common/notification';
import CustomLoader from '../../common/loader';
import CustomModal from '../../common/modal'
import Switch from "react-switch";
import AddServer from './components-modal/addServer';
import EditServerConfig from './components-modal/updateServerConfig';
import { RC_LOAD_LOGIN } from '../../routers/RouteConstants';
import { withRouter } from 'react-router-dom';


class ServerConfig extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User: getUser(),
            accountID: this.props.userId,
            serverList: [],
            isGetting: false,
            isModal: false,
            isDelModal: false,
            delIp: null,
            msg: '',
            name:'',
            updateMsg: '',
            isEditModal: false,
            previousData: [],
            isDelLoad:false
        }
        this.openModal = this.openModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.serverListing = this.serverListing.bind(this)
        this.delcloseModal = this.delcloseModal.bind(this)
        this.delopenModal = this.delopenModal.bind(this)
        this.deleteServer = this.deleteServer.bind(this)
        this.toggleSwitch = this.toggleSwitch.bind(this)
        this.openEditModal = this.openEditModal.bind(this)
        this.closeEditModal = this.closeEditModal.bind(this)
    }

    componentDidMount() {
        this.serverListing()
    }

    closeModal() {
        this.setState({ isModal: false })
    }
    openModal() {
        this.setState({ isModal: true })
    }
    openEditModal(row) {
        this.setState({
            isEditModal: true,
            previousData: row
        })
    }

    closeEditModal() {
        this.setState({
            isEditModal: false
        })
    }

    delcloseModal() {
        this.setState({ isDelModal: false })
    }
    delopenModal(ip) {
        this.setState({
            isDelModal: true,
            delIp: ip.id
        })
        console.log('ip :>> ', ip);
    }

    toggleSwitch(row) {
        const { User, accountID } = this.state
        var user = row;
        const data = {
            "ip": row.ip,
            "port": row.port,
            "mask": row.mask,
            "active": !user.status
        }
        var headers = { "Authorization": "Bearer " + User.token };
        axios.put(`${SERVER_TOGGAL}/${accountID}/server/${row.id}/update`, data, { headers }).then(res => {
            if (res) {
                this.setState({
                    updateMsg: res.data.message
                })
                this.serverListing()
                Notifications.notify(this.state.updateMsg, "Success", "success");
            }
        }).catch(err => {
            console.log('err :>> ', err);
            Notifications.notify("Failed to fetch", "Failed", "errors")

        })

    }

    serverListing() {
        const { User, accountID } = this.state
        this.setState({
            isGetting: true
        })
        var headers = { "Authorization": "Bearer " + User.token };
        axios.get(`${SERVER_LISTING}/${accountID}/server?page=1&limit=50`, { headers }).then(res => {
            if (res) {
                console.log('res :>> ', res);
                this.setState({
                    serverList: res.data.data,
                    isGetting: false
                })
            }
            else {
                Notifications.notify("Fetch failed", "error", "errors")
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.props.history.push(LOGIN_URL)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false
            })
        })
    }

    renderServerListing() {
        const { serverList } = this.state
        console.log(serverList)
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if (serverList === null) {
            return nullData
        }
        else {
            return serverList.map((row, idx) => {
                return (
                    <tr key={idx}>
                        <td style={{textAlign:'center'}}>{row.ip}</td>
                        <td style={{textAlign:'center'}}>{row.techPrefix}</td>
                        <td style={{textAlign:'center'}}>{row.mask}</td>
                        <td style={{textAlign:'center'}}>{row.port}</td>
                        <td style={{textAlign:'center'}}>{row.enabled === false ? <span className="badge badge-danger">No</span> : <span className="badge badge-success">Yes</span>}</td>
                        {/* <td><span className="size-1"><Switch height={20} width={50} onChange={this.toggleSwitch.bind(this, row)} checked={row.active} /></span></td> */}
                        <td className='edit-button'><i className=" fa fa-edit mr-2" onClick={this.openEditModal.bind(this, row)} ></i><i className="text-danger fa fa-trash" aria-hidden="true" onClick={this.delopenModal.bind(this, row)}></i></td>
                    </tr>
                )
            })
        }
    }

    deleteServer() {
        const { accountID, User, delIp } = this.state
        console.log('delIp :>> ', delIp);
        var headers = { "Authorization": "Bearer " + User.token };
        this.setState({isDelLoad:true})
        axios.delete(`${DELETE_SERVER_URL}/${accountID}/server/${delIp}/delete`, { headers }).then(res => {
            if (res) {
                this.setState({
                    msg: res.data.message,
                    isDelLoad:false
                })
                this.delcloseModal()
                this.serverListing()
                Notifications.notify(this.state.msg, "Success", "success")
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.props.history.push(LOGIN_URL)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false
            })
        })
    }

    render() {
        const { isGetting, isModal, accountID, isDelModal, isEditModal, previousData, isDelLoad } = this.state
        let addServerModal = {
            details: {
                info: "Add Server",
                msg: <AddServer close={this.closeModal} accountID={accountID} listingServer={this.serverListing} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeModal },
            cancelBtn: { label: "Cancel", action: this.closeModal }
        }
        let editServer = {
            details: {
                info: "Update Server",
                msg: <EditServerConfig mainID={this.state.accountID} previousDetails={previousData} serverListing={this.serverListing} close={this.closeEditModal} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeEditModal },
            cancelBtn: { label: "Cancel", action: this.closeEditModal }
        }

        var delModal = (
            <div>
                <div class="modal-body">
                    <h4>Are you sure want to delete {this.state.ip} ? </h4>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light" onClick={this.delcloseModal} data-dismiss="modal">Close</button>
                    <button  type="button" class="btn btn-success main-button" onClick={this.deleteServer} disabled={this.state.isDelLoad ? true : false} > Confirm  {this.state.isDelLoad ? <i class="fas fa-spinner fa-spin ml-1"></i> : <i class="icon-file-plus ml-1 icon-1x"></i>}</button>
                </div>
            </div>
        )
        let delServerModal = {
            details: {
                info: "Delete Server",
                msg: delModal
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.delcloseModal },
            cancelBtn: { label: "Cancel", action: this.delcloseModal }
        }
        return (
            <div>
                <CustomModal
                    visibility={isModal}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    details={addServerModal.details}
                    showBtns={false}
                    cancelBtn={addServerModal.cancelBtn}
                    crossBtn={addServerModal.crossBtn}
                />
                <CustomModal
                    visibility={isEditModal}
                    modalType={"success"}
                    modalHeader={'success'}
                    details={editServer.details}
                    showBtns={false}
                    cancelBtn={editServer.cancelBtn}
                    crossBtn={editServer.crossBtn}
                />
                <CustomModal
                    visibility={isDelModal}
                    customBodyCSS={"h20"}
                    modalType={"danger"}
                    modalHeader={"danger"}
                    details={delServerModal.details}
                    showBtns={false}
                    cancelBtn={delServerModal.cancelBtn}
                    crossBtn={delServerModal.crossBtn}
                />
                <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body">
                    <div className="card-header header-elements-inline p-0 py-1">
                        <h5 style={{fontWeight:'700',fontSize:'24px'}} className="card-title"></h5>
                        <div className="header-elements">
                            <button type="submit" className="main-button btn btn-sm btn-success ml-3" onClick={this.openModal} >Add Server <i className="fas fa-plus ml-2"></i></button>
                        </div>
                    </div>
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                        <div className="datatable-header">
                            <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                {/* <label><span>Filter:</span>
                                    <input type="search" className="" placeholder="Type to filter..."  aria-controls="DataTables_Table_0" />
                                </label> */}
                            </div>
                        </div>
                        <div className="datatable-scroll" style={{overflowX: 'auto'}}>
                            <table style={{border:'1px solid #ddd',borderTop:'0px solid #ddd',borderCollapse:'collapse'}} className="table table-striped  no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr className="stickeyHeader">
                                        {/* <th>Title</th> */}
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Source IP</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Tech Prefix</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Mask</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Port</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Enabled</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isGetting ? <CustomLoader /> : this.renderServerListing()}
                                </tbody>
                            </table>
                        </div>
                        {/* <div className="datatable-footer">
                            <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 1 to 10 of 15 entries</div>
                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(ServerConfig)